import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators,} from '@angular/forms';
import {Select, Store} from '@ngxs/store';
import {AppState} from '../../../state/appState';
import {Observable, Subscription} from 'rxjs';
import {MerchantModel} from '../../../shared/models/merchant.model';
import {debounceTime} from 'rxjs/operators';
import {ReportFilterModel} from '../../../shared/models/reportFilter.model';
import {ReportModel} from '../../../shared/models/report.model';
import {RequestFilterModel} from '../../../shared/models/requestFilterModel';
import {DownloadCustomerSalesReport, SetCustomerSalesReportFilter,} from '../../../state/actions/report.actions';

@Component({
  selector: 'app-customer-report',
  templateUrl: './customer-report.component.html',
  styleUrls: ['./customer-report.component.scss'],
})
export class CustomerReportComponent implements OnInit, OnDestroy {
  @Select(AppState.currentMerchant$)
  currentMerchant$: Observable<MerchantModel>;
  @Select(AppState.customerSalesReport$)
  customerSalesReport$: Observable<ReportModel>;
  @Select(AppState.customerSalesReportFilter$)
  customerSalesReportFilter$: Observable<ReportFilterModel>;

  public reportForm: UntypedFormGroup;
  private subscriptions: Subscription[] = [];

  constructor(private fb: UntypedFormBuilder, private store: Store) {
  }

  ngOnInit(): void {
    this.initForm();

    this.subscriptions.push(
      this.customerSalesReportFilter$.subscribe(f => {
        this.reportForm.patchValue(f, {emitEvent: false, onlySelf: true});
      })
    );

    this.subscriptions.push(
      this.reportForm.valueChanges.pipe(debounceTime(1000)).subscribe(s => {
        console.log(s);
        if (this.reportForm.valid) {
          this.propagateChanges();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  initForm(): void {
    this.reportForm = this.fb.group({
      cardId: new FormControl<string>('', []),
      posId: new FormControl<string>('', []),
      posName: new FormControl<string>('', []),
      deviceId: new FormControl<string>('', []),
      fromDate: new FormControl<Date>(null, [Validators.required]),
      toDate: new FormControl<Date>(null, [Validators.required]),
    });
  }

  public propagateChanges(): void {
    const f: RequestFilterModel = this.reportForm.getRawValue();
    this.store.dispatch(new SetCustomerSalesReportFilter(f));
  }

  public downloadCSV(): void {
    this.store.dispatch(new DownloadCustomerSalesReport());
  }

  submitReportForm(): void {
  }
}
